<template>
  <v-container>
    <v-card
      class="pa-2"
      flat
    >
      <div
        class="px-4 pt-3 text-uppercase font-weight-bold"
        style="font-size:30pt"
      >
        Paramètres
      </div>
      <v-divider
        class="ml-4"
        style="width: 100px;border:1px solid red; border-radius: 5px"
        color="cyan"
        inset
      />
    
      <v-switch
        v-model="$vuetify.theme.dark"
        hint=""
        inset
        label="Mode sombre"
        persistent-hint
      />

      <v-btn
        class="mb-2"
        color=""
        block
        to="Account"
      >
        Compte
      </v-btn>
      
      <v-dialog
        v-model="dialog"
        width="600px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color=""
            v-bind="attrs"
            block
            v-on="on"
          >
            Politique de confidentialité
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Politique de confidentialité</span>
          </v-card-title>
          <v-card-text>
            Introduction
            <v-spacer />
            Dans le cadre de son activité, la société [Société], dont le siège social est situé au [Adresse du siège social], est amenée à collecter et à traiter des informations dont certaines sont qualifiées de "données personnelles". [Société] attache une grande importance au respect de la vie privée, et n’utilise que des donnes de manière responsable et confidentielle et dans une finalité précise.
            <v-spacer />
            Données personnelles<v-spacer />
            Sur le site web [Adresse du site], il y a 2 types de données susceptibles d’être recueillies :<v-spacer />

            Les données transmises directement<v-spacer />
            Ces données sont celles que vous nous transmettez directement, via un formulaire de contact ou bien par contact direct par email. Sont obligatoires dans le formulaire de contact le champs « prénom et nom », « entreprise ou organisation » et « email ».<v-spacer />
            Les données collectées automatiquement<v-spacer />
            Lors de vos visites, une fois votre consentement donné, nous pouvons recueillir des informations de type « web analytics » relatives à votre navigation, la durée de votre consultation, votre adresse IP, votre type et version de navigateur. La technologie utilisée est le cookie.<v-spacer />
            Utilisation des données<v-spacer />
            Les données que vous nous transmettez directement sont utilisées dans le but de vous re-contacter et/ou dans le cadre de la demande que vous nous faites. Les données « web analytics » sont collectées de forme anonyme (en enregistrant des adresses IP anonymes) par Google Analytics, et nous permettent de mesurer l'audience de notre site web, les consultations et les éventuelles erreurs afin d’améliorer constamment l’expérience des utilisateurs. Ces données sont utilisées par [Société], responsable du traitement des données, et ne seront jamais cédées à un tiers ni utilisées à d’autres fins que celles détaillées ci-dessus.<v-spacer />

            Base légale<v-spacer />
            Les données personnelles ne sont collectées qu’après consentement obligatoire de l’utilisateur. Ce consentement est valablement recueilli (boutons et cases à cocher), libre, clair et sans équivoque.
            <v-spacer />
            Durée de conservation<v-spacer />
            Les données seront sauvegardées durant une durée maximale de 3 ans.<v-spacer />

            Cookies<v-spacer />
            Voici la liste des cookies utilisées et leur objectif :<v-spacer />

            Cookies Google Analytics (liste exhaustive) : <v-spacer /> Web analytics<v-spacer />
            [Nom du cookie] : Permet de garder en mémoire le fait que vous acceptez les cookies afin de ne plus vous importuner lors de votre prochaine visite.<v-spacer />
            Vos droits concernant les données personnelles<v-spacer />
            Vous avez le droit de consultation, demande de modification ou d’effacement sur l’ensemble de vos données personnelles. Vous pouvez également retirer votre consentement au traitement de vos données.<v-spacer />

            Contact délégué à la protection des données <v-spacer />
            [Nom du contact] - [Idéalement au moins 2 façons de le contacter]<v-spacer />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              @click="dialog = false"
            >
              Fermer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name : 'Settings',
    data () {
      return {
        dialog: false,
      }
    },
  }
</script>